import { gsap } from "gsap";
import { Draggable } from "gsap/Draggable";

gsap.registerPlugin(Draggable);

class DragAppIcon {
  constructor(el, callback) {
    if (window.debug) {
      console.log(`DragAppIcon initiated for ${el}`);
    }
    this.callback = callback;
    this.elem = document.querySelector(el);
    this.dragEl = this.elem.querySelector(".draggable");
    this.dropEl = this.elem.querySelector(".dropzone");
    this.inZone = false;
    this.pulse = null;
    this.draggable = Draggable.create(this.dragEl, {
      bounds: this.elem,
      onDragStart: this.onDragStart.bind(this),
      onDrag: this.onDrag.bind(this),
      onDragEnd: this.onDragEnd.bind(this),
    })[0];
  }
  onDragStart() {
    let parentNode = this.dragEl.parentNode;
    let pulse = parentNode.querySelector(".app-drawer__pulse");
    if (pulse) {
      this.pulse = pulse;
      this.pulse.classList.add("hidden");
    }
  }
  onDrag() {
    this.inZone = Draggable.hitTest(this.dragEl, this.dropEl, "25%");
  }
  onDragEnd() {
    if (!this.inZone) {
      gsap.to(this.dragEl, { duration: 0.2, x: 0, y: 0 });
    } else {
      let obj = this.dragEl.getBoundingClientRect();
      let zone = this.dropEl.getBoundingClientRect();
      let x = "+=" + (zone.left - obj.left);
      let y = "+=" + (zone.top - obj.top);
      gsap.to(this.dragEl, {
        duration: 0.3,
        x: x,
        y: y,
        onComplete: () => {
          Draggable.get(this.dragEl).disable();
          this.callback();
        },
      });
    }
  }
  reset() {
    if (this.pulse) {
      this.pulse.classList.remove("hidden");
    }
    gsap.set(this.dragEl, { x: 0, y: 0, opacity: 1 });
    Draggable.get(this.dragEl).enable();
  }
}

export { DragAppIcon };
